export default __webpack_public_path__ + "static/media/farwest_vs_foreal.4f5b67bd.jpg";